export const sentryIgnoreList = ["Failed to fetch dynamically imported module"];
